var map = {
	"./white/0.25.svg": 790,
	"./white/0.5.svg": 791,
	"./white/0.75.svg": 792,
	"./white/0.svg": 793,
	"./white/1.svg": 794,
	"./white/10.svg": 795,
	"./white/11.svg": 796,
	"./white/2.svg": 797,
	"./white/3.svg": 798,
	"./white/4.svg": 799,
	"./white/5.svg": 800,
	"./white/6.svg": 801,
	"./white/7.svg": 802,
	"./white/8.svg": 803,
	"./white/9.svg": 804,
	"./yellow/0.25.svg": 805,
	"./yellow/0.5.svg": 806,
	"./yellow/0.75.svg": 807,
	"./yellow/0.svg": 808,
	"./yellow/1.svg": 809,
	"./yellow/10.svg": 810,
	"./yellow/11.svg": 811,
	"./yellow/2.svg": 812,
	"./yellow/3.svg": 813,
	"./yellow/4.svg": 814,
	"./yellow/5.svg": 815,
	"./yellow/6.svg": 816,
	"./yellow/7.svg": 817,
	"./yellow/8.svg": 818,
	"./yellow/9.svg": 819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 789;